import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';

@Component({
  selector: 'app-clientid-login',
  templateUrl: './clientid-login.component.html',
  styleUrls: ['./clientid-login.component.scss']
})
export class ClientidLoginComponent implements OnInit {

  constructor(private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const jwt = params['jwt'];
      if (jwt) {
        this.authService.tokenLogin(jwt);
      } else {
        this.redirecToLogin();
      }
    });
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

  private redirecToLogin() {
    window.location.href = (`${environment.logoutRedirectUrl}`);
  }

}
